import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CampaignViewAllTabsProps } from "./campaig-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import CampaignViewDetails from "./campaign-view-details/campaign-view-details";
import CampaignViewTimeline from "./campaign-view-timeline/campaign-view-timeline";
import CampaignViewDetailsViewAttachmentInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-attachment-info/campaign-view-details-view-attachment-info";
import CampaignViewDetailsViewActivitiesInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/campaign-view-details-view-activities-info";
import CampaignViewDetailsViewLeadsInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-leads-info/campaign-view-details-view-leads-info";
import "./campaign-view.scss";
import CampaignViewDetailsViewContactInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-contact-info/campaign-view-details-view-customer-info";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CampaignEmailInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-email/campaign-email-info";

// … rest of your imports remain the SAME…

const CampaignsViewDetailsAllTabsResponsive: React.FC<
  CampaignViewAllTabsProps
> = ({
  campaignDetails,
  selectedCampaignId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchCampaignDetails,
  campaignId,
  onCampaignNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  setViewTaskvalue,
  setCrumbMappingOption,
  permissions,
  setViewMeetingvalue,
  viewCallValue,
  setViewCallValue,
}) => {
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [indexValue, setIndexValue] = useState(0);
  const [updatedDate, setUpdatedDate] = useState<string | undefined>();
  const [selectedAccordion, setSelectedAccordion] = useState(null);

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ) => {
    setIndexValue(newValue);
    setViewFullInfoOpen(false);
  };

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleAccordionChange =
    (panel: any) => (even: any, isExpanded: any) => {
      setSelectedAccordion(isExpanded ? panel : false);
    };

  return (
    <div className="leads-view-all-tabs">
      {/* Detailed View */}
      <Box>
        {/* 1. Primary details */}
        <Accordion
          expanded={selectedAccordion === "panel1"}
          onChange={handleAccordionChange("panel1")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Details
          </AccordionSummary>
          <AccordionDetails className="no-padding-accordion-details">
            <CampaignViewDetails
              campaignDetails={campaignDetails}
              selectedCampaignId={selectedCampaignId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchCampaignDetails={fetchCampaignDetails}
              onCampaignNameUpdate={onCampaignNameUpdate}
              resetImageUpload={resetImageUpload}
              permissions={permissions}
            />
          </AccordionDetails>
        </Accordion>

        {/* 3. Attachments */}
        <Accordion
          expanded={selectedAccordion === "panel2"}
          onChange={handleAccordionChange("panel2")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Attachments
          </AccordionSummary>
          <AccordionDetails>
            <CampaignViewDetailsViewAttachmentInfo
              setLoading={setLoading}
              campaignId={campaignId}
              permissions={permissions}
            />
          </AccordionDetails>
        </Accordion>

        {/* 5. Activities */}
        <Accordion
          expanded={selectedAccordion === "panel3"}
          onChange={handleAccordionChange("panel3")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Activities
          </AccordionSummary>
          <AccordionDetails>
            <CampaignViewDetailsViewActivitiesInfo
              campaignDetails={campaignDetails}
              setViewTaskvalue={setViewTaskvalue}
              setCrumbMappingOption={setCrumbMappingOption}
              permissions={permissions}
              setViewMeetingvalue={setViewMeetingvalue}
              setViewCallValue={setViewCallValue}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Email
          </AccordionSummary>
          <AccordionDetails>
            <CustomTabPanelComponent value={indexValue} index={3}>
              <CampaignEmailInfo
                campaignDetails={campaignDetails}
                setLoading={setLoading}
                setAlertMessage={setAlertMessage}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                permissions={permissions}
                fetchCampaignDetails={fetchCampaignDetails}
              />
            </CustomTabPanelComponent>
          </AccordionDetails>
        </Accordion>

        {/* 5. Leads */}
        <Accordion
          expanded={selectedAccordion === "panel4"}
          onChange={handleAccordionChange("panel4")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Leads
          </AccordionSummary>
          <AccordionDetails>
            <CampaignViewDetailsViewLeadsInfo
              allCampaignData={selectedCampaignId}
              setLoading={setLoading}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              permissions={permissions}
            />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={selectedAccordion === "panel5"}
          onChange={handleAccordionChange("panel5")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Customers
          </AccordionSummary>
          <AccordionDetails>
            <CampaignViewDetailsViewContactInfo
              allCampaignData={selectedCampaignId}
              permissions={permissions}
              setLoading={setLoading}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
            />
          </AccordionDetails>
        </Accordion>

        {/* 7. Timeline */}
        <Accordion
          expanded={selectedAccordion === "panel6"}
          onChange={handleAccordionChange("panel6")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Timeline
          </AccordionSummary>
          <AccordionDetails>
            <CampaignViewTimeline
              selectedCampaignId={selectedCampaignId}
              setLoading={setLoading}
              setUpdatedDate={setUpdatedDate}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
            />
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};

export default CampaignsViewDetailsAllTabsResponsive;
